import { Component, ChangeDetectionStrategy } from '@angular/core';

import { GalaxyCardComponent } from '@app/components/ui/galaxy-card/galaxy-card.component';

@Component({
  selector: 'app-benefits',
  imports: [GalaxyCardComponent],
  templateUrl: './benefits.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./benefits.component.css'],
})
export class BenefitsComponent {}
